// PatchCenterLayout.jsx
import { Outlet } from 'react-router-dom';
import { PatchFormProvider } from '../../providers/PatchFormProvider';

const PatchCenterLayout = () => {
  return (
    <PatchFormProvider>
      <Outlet />
    </PatchFormProvider>
  );
};

export default PatchCenterLayout;
